export default {
  'recurring.accordionHeader': 'Recurring Transfer',
  'recurring.deleteHeader': 'Delete Recurring Payment',
  'recurring.deleteMessage':
    'The instruction will be deleted and all pending transfers will be canceled.',
  'recurring.deleteConfirm': 'Do you want to proceed?',
  'transfers.delete.success.message': 'Deleted Successfully',
  'transfers.delete.fail.message': 'Delete Failure',
  'recurring.fromAccount': 'From Account',
  'recurring.toAccount': 'To Account',
  'recurring.createdBy': 'Created By',
  'recurring.amount': 'Amount',
  'recurring.nextDate': 'Next Date',
  'recurring.memo': 'Memo',
  'recurring.schedule': 'Schedule',
  'recurring.priorAfter': 'Prior/After'
};
